import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  Button, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, UncontrolledTooltip,
  InputGroup,
  InputGroupButtonDropdown,Modal,ModalBody,Form,FormGroup
} from "reactstrap";
import {
  Link
} from "react-router-dom";
import ProjectService from '../../services/api/Project';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
// import { toast } from '../../settings/shared/constants';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { uuidv4 } from '../../components/Notebook/operations/notebook';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import Autosuggest from "react-autosuggest";
import "react-multi-carousel/lib/styles.css";
import 'assets/css/avatargrp.scss';
import 'assets/css/bc.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import Pagination from "assets/js/Pagination";


function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  return (
    <span>{suggestion.name}</span>
  );
}

class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectDTOS: [],
      setFav: '',
      allprojectlength: '',
      tags: [],
      recentprojectDTOS: [],
      recentproject: '',
      from: "Recents",
      showAll: false,
      showRecents: false,
      showFavorites: false,
      tagDTOS: [],
      projectTag: [],
      searchBy: "",
      ProjectSrch: false,
      TagSrch: false,
      tagText: '',
      dropdownOpen: false,
      filterBy: "Projects",
      suggestions: [],
      value: "",
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      activeTab : "Recents",
      currentPageNumber : 0,
      totalPages : 0,
      modalAccount: false,
      landingData : [
      {label : "Creating Accounts", loading : true},
      {label : "Creating Default Projects", loading : true},
      {label : "Setting Projects Files", loading : true}]
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }
  componentDidMount() {
    this.setState({ loading: true })
    if (localStorage.getItem("lastLogin") === "true") {
      this.getRecentsProjects();
    } else {
      this.handleOpen();
    }
    localStorage.setItem("Pagehistory", "project");
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  getRecentsProjects = () =>{
    ProjectService.GetRecentProject(this.state.currentPageNumber,15)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let responseData = response.projectDTOSPage;
            if(responseData.content !== null && responseData.content.length > 0){
            this.setState({
              showAll: false,
              showRecents: true,
              showFavorites: false,
              projectDTOS: responseData.content,
              searchprojectdata: responseData.content,
              recentproject: responseData.content.length,
              value: "",
              loading : false,
              totalPages : responseData.totalPages
            });
          }else{
              this.onChangeTab("All");
          }
          }else{
              this.setState({ errorMessage: "No Recent Projects Found", loading: false });
          }  
        });
  }


  onChangeTab = (tabId) => {
    this.setState({
      activeTab: tabId,
      currentPageNumber: 0
    }, () => this.getProjects(this.state.activeTab))
  }


  handleOpen = () => {
    if (localStorage.getItem("initpage") === null) {
      localStorage.setItem("initpage", "show");
      this.setState({
        modalAccount: true
      }, () => {
        this.state.landingData.forEach((element, i) => {
          setTimeout(
            () => {
              this.state.landingData[i].loading = false;
              this.setState({
                landingData: this.state.landingData
              })
            }
            , i * 3000);
        });
        setTimeout(() => {
          this.setState({
            modalAccount: false
          }, () => {
            this.getRecentsProjects();
          })
        }, 7000);
      })
    }
    else {
      this.getRecentsProjects();
    }
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.setState({
        projectDTOS: this.state.searchprojectdata,
      })
    }
  };
  onChangeTags = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
    if (newValue === "") {
      this.setState({
        projectDTOS: this.state.searchprojectdata,
      })
    }
  };

  onPageChange = (pageIndex) =>{
    this.setState({
      currentPageNumber: pageIndex
    },()=>{
      this.getProjects(this.state.activeTab);
    });
  }

  onSuggestionsProjectFetchRequested = ({ value }) => {
    let from = "project"
    let tagOption = [];
    if (value === "") {
      this.setState({
        projectDTOS: this.state.searchprojectdata,
      })
    }
    ProjectService.GetTags(from, value)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.searchListAutoComplete;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i],
              value: myTags[i],
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionProjectSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    let from = "project";
    ProjectService.GetAutoCompleteResult(from, suggestion.name)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let responseData = response.projectDTOSPage;
          if(responseData.content !== null){
          this.setState({
            projectDTOS: responseData.content,
          })
        }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionsTagFetchRequested = ({ value }) => {
    let from = "tag"
    let tagOption = [];
    if (value === "") {
      this.setState({
        projectDTOS: this.state.searchprojectdata,
      })
    }
    ProjectService.GetTags(from, value)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let myTags = response.searchListAutoComplete;
          this.setState({
            tagDTOS: myTags,
            searchtagdata: myTags,
          });
          for (let i = 0; i < myTags.length; i++) {
            tagOption.push({
              name: myTags[i],
              value: myTags[i],
            })
          }
          this.setState({ loading: false, suggestions: tagOption });
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
    // this.setState({ value: '' });

  }
  onSuggestionTagSelected = (event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    let from = "tag"
    ProjectService.GetAutoCompleteResult(from, suggestion.name)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let responseData = response.projectDTOSPage;
          if(responseData.content !== null){
          this.setState({
            projectDTOS: responseData.content
          })
        }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }
  editProject = (id, name) => {
    let reg = "/project";
    localStorage.setItem("Pagehistory", "project");
    this.props.history.push({
      pathname: '/newProject/?__o=' + reg,
      state: { mode: "editProject", editId: id, editProject: name }
    })
  }
  runProject = (id, name) => {
    let reg = "/project";
    localStorage.setItem("Pagehistory", "project");
    this.props.history.push({
      pathname: '/newProject/?__o=' + reg,
      state: { mode: "runProject", runPId: id, runName: name }
    })
  }
  cloneProject = (id, name) => {
    let reg = "/project";
    localStorage.setItem("Pagehistory", "project");
    this.props.history.push({
      pathname: '/newProject/?__o=' + reg,
      state: { mode: "cloneProject", cloneId: id, editId: id, editProject: name, from: 'project' }
    })
  }
  viewProject = (id, name, chatMasterId) => {
    let reg = "/project";
    localStorage.setItem("Pagehistory", "project");
    this.props.history.push({
      pathname: '/viewProject/' + id + '?__o=' + reg,
      state: { mode: "viewProject", viewId: id, viewname: name, chatmasterId: chatMasterId }
    })
  }

  addToFav = (id, favitem) => {
    let setfav;
    if (favitem === true) {
      setfav = false
    }
    else {
      setfav = true
    }
    if (this.state.projectDTOS.length > 0 && id !== undefined) {
      let index = this.state.projectDTOS.findIndex(item => item.id === id);
      if (index !== -1) {
        let items = [...this.state.projectDTOS];
        let item = { ...items[index] };
        item.favoriteItem = setfav;
        items[index] = item;
        this.setState({ projectDTOS: items });
        ProjectService.FavoriteProject(id, setfav)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              if (this.state.activeTab === "Favorites") {
                this.getProjects(this.state.activeTab)
              }
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
            }
          });
      }
    }
  }

  // Delete particular user
  deleteProject = (id, name) => {
    confirmAlert({
      title: "Delete Project",
      message: 'Are you sure to delete this project - ' + name + "?",
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.confirmDelete(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
  confirmDelete(id) {
    ProjectService.Deleteproject(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Project Deleted Successfully!</b></i>); 
          this.getProjects(this.state.activeTab);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  
  //Get All Project
  getProjects = (from) => {
    this.setState({
      loading: true,
      from: from,
      projectDTOS : []
    });
    if (from === "All") {
      ProjectService.GetProject(this.state.currentPageNumber,20)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let responseData = response.projectDTOSPage;
            if(responseData.content !== null){
            this.setState({
              showAll: true,
              showFavorites: false,
              showRecents: false,
              projectDTOS: responseData.content,
              searchprojectdata: responseData.content,
              allprojectlength: responseData.content.length,
              value: "",
              totalPages : responseData.totalPages

            });
            this.setState({ loading: false });
            }
            
          } else {
            this.setState({ errorMessage: response.errorMessage });
          }
          if (this.state.projectDTOS.length === 0) {
            this.setState({ errorMessage: "No Projects Found", loading: false });
          }
        });
    } else if (from === "Recents") {
      ProjectService.GetRecentProject(this.state.currentPageNumber,15)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let responseData = response.projectDTOSPage;
            if(responseData.content !== null){
            this.setState({
              showAll: false,
              showRecents: true,
              showFavorites: false,
              projectDTOS: responseData.content,
              searchprojectdata: responseData.content,
              recentproject: responseData.content.length,
              value: "",
              loading : false,
              totalPages : responseData.totalPages
            },()=>{
              if (this.state.projectDTOS.length === 0) {
                this.setState({ errorMessage: "No Recent Projects Found", loading: false });
              }
            });
          }
          }else{
              this.setState({ errorMessage: "No Recent Projects Found", loading: false });
          }  
        });

    } else if (from === "Favorites") {
      ProjectService.GetFavoriteProject(this.state.currentPageNumber,20)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let responseData = response.projectDTOSPage;
            if(responseData.content !== null){
            this.setState({
              showAll: false,
              showRecents: false,
              showFavorites: true,
              projectDTOS: responseData.content,
              searchprojectdata: responseData.content,
              favproject: responseData.content.length,
              value: "",
              loading : false,
              totalPages : responseData.totalPages
            });
          }
          } else {
            this.setState({ errorMessage: response.errorMessage });
          }
          if (this.state.projectDTOS.length === 0) {
            this.setState({ errorMessage: "No Favorites Projects Found", loading: false });
          }
        });
    }
  }

  searchBy = (value) => {
    this.setState({
      filterBy: value,
      value: "",
      projectDTOS: this.state.searchprojectdata,

    })
  }
  

  render() {
    const { value, suggestions } = this.state;
    const inputPropsproject = {
      placeholder: "Search By Project",
      value,
      onChange: this.onChange,
      id: "SProject",
    };
    const inputPropstags = {
      placeholder: "Search By Tags",
      value,
      onChange: this.onChangeTags,
      id: "STag",
    };
    return (
  
      <>
        <PanelHeader
          content={
            <div className="header text-center">
           </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardBody>
                    <div className="carcontent">
                      <Tabs defaultTab={this.state.activeTab} onChange={(tabId) => { this.onChangeTab(tabId)}}>
                        <div className="proj-search">
                          <TabList>
                            <Row>
                              <div className="col-12 col-md-5 col-xl-4 proj-tabs">
                                <Tab tabFor="All" className="adddatatab"> All</Tab>
                                <Tab tabFor="Recents" className="adddatatab"> Recents</Tab>
                                <Tab tabFor="Favorites" className="adddatatab"> Favorites</Tab>
                              </div>
                              <div className="col-6 col-md-4 col-xl-6">
                                <Row>
                                  <div className="col">
                                    <InputGroup className="prosrch">
                                      <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                                        <DropdownToggle caret>
                                          {this.state.filterBy}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem onClick={e => this.searchBy('Projects')}>Projects &nbsp;</DropdownItem>
                                          <DropdownItem divider />
                                          <DropdownItem onClick={e => this.searchBy('Tags')}>Tags &nbsp;</DropdownItem>
                                        </DropdownMenu>
                                      </InputGroupButtonDropdown>
                                      {this.state.filterBy === "Projects" &&
                                        <Autosuggest
                                          suggestions={suggestions}
                                          onSuggestionsFetchRequested={this.onSuggestionsProjectFetchRequested}
                                          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                          getSuggestionValue={getSuggestionValue}
                                          renderSuggestion={renderSuggestion}
                                          onSuggestionSelected={this.onSuggestionProjectSelected}
                                          inputProps={inputPropsproject} />
                                      }
                                      {this.state.filterBy === "Tags" &&
                                        <Autosuggest
                                          suggestions={suggestions}
                                          onSuggestionsFetchRequested={this.onSuggestionsTagFetchRequested}
                                          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                          getSuggestionValue={getSuggestionValue}
                                          renderSuggestion={renderSuggestion}
                                          onSuggestionSelected={this.onSuggestionTagSelected}
                                          inputProps={inputPropstags} />

                                      }
                                    </InputGroup>
                                  </div>
                                </Row>
                              </div>
                              <div className="col-6 col-md-3 col-xl-2 text-right">
                                <Link to={{
                                  pathname: 'newProject',
                                  state: { mode: "addnew", runName: "" }
                                }}>
                                  <Button
                                    color="primary"
                                    href=""
                                    size="sm"
                                  >
                                    New Project
                      </Button>
                                </Link>
                              </div>
                            </Row>
                          </TabList>
                        </div>
                        <CardBody>
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight-200}>
                            <TabPanel tabId={this.state.from}>
                              <CardBody>
                                <Row className="icon-examples projects-card">
                                  {this.state.projectDTOS.map((item, index) => (<Col className="sub-projects-card" key={uuidv4()} >
                                    <Col className="text-center" key={index}>
                                      <Card className="card-contributions hoverproject">
                                        <CardBody>
                                          <Row>
                                            <Col xs="12" className="overflowStyle" >
                                              <span key={index} className={item.favoriteItem === true ? "fas fa-star orange" : "far fa-star"} id={'fav' + index} style={{ cursor: 'pointer', fontSize: '15px' }} onClick={e => this.addToFav(item.id, item.favoriteItem)}></span>&nbsp;<b style={{ color: '#524848', fontSize: '15px', cursor: 'pointer' }} className="prohover" onClick={e => this.viewProject(item.id, item.name, item.chatMasterId)} title={item.name} >{item.name}</b>
                                              <UncontrolledTooltip placement="bottom" target={'fav' + index} delay={0}>
                                                {item.favoriteItem === true ? "Remove From Favorites" : "Add To Favorites"}
                                              </UncontrolledTooltip>
                                              <hr></hr>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col className="project-col" xs="4">
                                              <Button className="btn-icon btn-round btn btn-neutral" id={'editp' + index} onClick={e => this.editProject(item.id, item.name)} style={{ cursor: "pointer" }}>
                                                <i className="fas fa-edit" style={{ fontSize: '18px' }} />
                                              </Button>
                                              <UncontrolledTooltip placement="bottom" target={'editp' + index} delay={0}>
                                                Edit
                        </UncontrolledTooltip>
                                            </Col>
                                            <Col className="project-col" xs="4">
                                              <Button className="btn-icon btn-round btn btn-neutral" id={'runp' + index} onClick={e => this.runProject(item.id, item.name)} style={{ cursor: "pointer" }}>
                                                <i className="fas fa-running" style={{ fontSize: '18px' }} />
                                              </Button>
                                              <UncontrolledTooltip placement="bottom" target={'runp' + index} delay={0}>
                                                Run
                        </UncontrolledTooltip>
                                            </Col>
                                            <Col className="project-col" xs="4">
                                              <UncontrolledDropdown>
                                                <DropdownToggle
                                                  tag="span"
                                                  onClick={e => e.preventDefault()}
                                                  style={{ color: '#007bff', cursor: 'pointer' }}
                                                >
                                                  <Button className="btn-icon btn-round btn btn-neutral" >
                                                    <i className="fas fa-ellipsis-v" style={{ fontSize: '18px' }} />
                                                  </Button>

                                                </DropdownToggle>
                                                <DropdownMenu
                                                  right
                                                  className="dropdown-menu-arrow"
                                                >
                                                  <DropdownItem
                                                    href="" onClick={e => this.cloneProject(item.id, item.name)} style={{ cursor: "pointer" }}>
                                                    <span>
                                                      <i className="far fa-clone text-red mr-3" />Clone
        </span>
                                                  </DropdownItem>
                                                  <DropdownItem
                                                    href="" onClick={e => this.deleteProject(item.id, item.name)} style={{ cursor: "pointer" }}>
                                                    <span>
                                                      <i className="fas fa-trash-alt text-red mr-3" />Delete
        </span>
                                                  </DropdownItem>
                                                </DropdownMenu>
                                              </UncontrolledDropdown>

                                            </Col>
                                          </Row>
                                        </CardBody>



                                      </Card>
                                    </Col>
                                  </Col>
                                  ))}

                                  {this.state.projectDTOS.length === 0 && <Col>
                                    <div style={{ justifyContent: "center", textAlign: "center" }}>
                                      <span>{this.state.errorMessage}</span>
                                    </div>
                                  </Col>
                                  }
                                </Row>
                              </CardBody>
                            </TabPanel>
                          </Scrollbars>
                          <Pagination
                         pages= {this.state.totalPages}
                         page={this.state.currentPageNumber}
                         onPageChange={this.onPageChange}
                         previousText="Previous"
                         nextText="Next"
                        />
                        </CardBody>
                      </Tabs>
                    </div>
                  </CardBody>
                </Card>

              </Col>
            </Row>
          </LoadingOverlay>
          <Modal isOpen={this.state.modalAccount} backdrop="static" className="init-acc">
            <ModalBody className="p-0">
              <div className="init-content">
                <div className="init-block">
                  <Card className="m-0">
                    <CardBody>
                      <Form className="p-3">
                        <FormGroup check className="m-3 p-0">
                        {this.state.landingData.map((item, index) => (
                            <div className="group" key={index}>
                              {!item.loading && <i className="fas fa-check-circle"></i>}
                              <label  className={item.loading ? "fades" : ""}> {item.label}</label> 
                              {item.loading && <span></span>}
                            </div>
                          ))}
                        </FormGroup>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </>

    );
  }
}

export default Project;
